import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "analytics",
  "use": "analytics-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" fill=\"currentColor\" id=\"analytics\"><path d=\"M4 16h3v14H4zM11 12h3v18h-3zM18 14h3v16h-3zM25 8h3v22h-3zM4.45 9.77l-.9-1.79 8.35-4.17 6.98 1.99L27.51 1l.98 1.75-9.37 5.2-7.02-2.01-7.65 3.83z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/analytics.svg
// module id = Fggw
// module chunks = 39 44